/**
 * PHARMAKON — brand identity tokens
 *
 * Ported from the design's config/brand.config.js. Used by LoginPage and
 * AppShell brand mark. Wordmark renders as: PHARMAKON with an accent dot
 * on the I — implementation lives in the <Wordmark /> primitive.
 */

export const BRAND = {
  name: "PHARMAKON",
  productName: "Pharmakon",
  tagline: "Système de gestion pharmaceutique.",
  positioning: "CNAS, CHIFA, stock, POS — réunis.",
  capabilityLines: [
    "Tiers-payant CHIFA en temps réel.",
    "Gestion FEFO automatique des lots.",
    "E-facture B2B avec vos fournisseurs.",
    "Aide à la décision pour vos commandes.",
    "Caisse, stock, achats — une seule fenêtre.",
  ],
  copyright: "© Pharmakon · Alger · v2.0",
};

export default BRAND;
